export const COLLECTION_OVERVIEW_OPTIONS = [
  { value: "mediaBias", label: "Media Bias" },
  { value: "category", label: "Source Category" },
];

export const normalizeCollectionOverviewValue = (value) => {
  const normalizedValue = String(value || "").trim().toLowerCase();

  if (normalizedValue === "category" || normalizedValue === "source category") {
    return "category";
  }

  if (
    normalizedValue === "mediabias" ||
    normalizedValue === "media bias" ||
    normalizedValue === "media bias rating"
  ) {
    return "mediaBias";
  }

  return "mediaBias";
};
